export default "__VITE_ASSET__CyigZ0Gb__"